
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["wordcloud-demo-en-0","wordcloud-demo-en-1"],
  getter: () => import(/* webpackChunkName: "meta__WordCloud__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.en.md?type=demo')
};